/*
* @Des 组件 室外 实时位置
* @Description
* @Author 
* @Date 2023/5/20
*/
<template>
	<div class="view-tree-table">
		<!-- router-title-box start -->
		<div class="router-title-box" v-if="false">
			<a href="javascript:void(0);" class="router-title-back cursor-pointer" @click="closeRouter" title="返回首页"></a>
			<div class="router-title-tit"></div>
		</div>
		<!-- router-title-box end -->
		<OutdoorRealPosition ref="outdoorRealPosition" />
	</div>
</template>

<script>
	// 引入组件 室外 实时定位
	import OutdoorRealPosition from '@/components_outdoor/Outdoor/OutdoorRealPosition';
	
	export default {
		/**
		 * @Des 组件名称
		 * @Auth
		 * @Date 2023/5/20
		 */
		name: 'OutdoorMonitor',
		/**
		 * @Des 组件注册
		 * @Auth
		 * @Date 2023/5/20
		 */
		components: {
			// 组件 室外 实时定位
			OutdoorRealPosition,
		},
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date 2023/5/20
		 */
		props: {
			
		},
        
		/**
		 * @Des 加载执行 pre
		 * @Auth
		 * @Date 2023/5/20
		 */
		created() {
			
		},
		/**
		 * @Des 加载完成执行
		 * @Auth
		 * @Date 2023/5/20
		 */
		mounted() {
			// body class
			document.getElementsByTagName('body')[0].className = 'home-page-view';
		},
		/**
		 * @Des 销毁之前执行
		 * @Auth
		 * @Date 2023/5/20
		 */
		beforeDestroy() {
			// body class
			document.getElementsByTagName('body')[0].className = 'home-page-view';
		},
		
		/**
		 * @Des 数据模型
		 * @Auth
		 * @Date 2023/5/20
		 */
		data() {
			return {
				
			}
		},
		/**
		 * @Des 方法
		 * @Auth
		 * @Date 2023/5/20
		 */
		methods: {
			/**
			 * @Des 关闭路由 
			 * @Auth
			 * @Date 2023/5/20
			 */
			closeRouter () {
				// 跳转到 首页
				this.$router.replace({path: this.$store.state.homePage}, ()=>{}, ()=>{});
			},// closeRouter
			
		},// methods
		
	}// export default
</script>

/* CSS */
<style lang="scss" scoped>
	.router-title-box {
		position: absolute;
	}
</style>


// WEBPACK FOOTER //
// src/views/system-outdoor/outdoor/OutdoorMonitor.vue